export default "__VITE_ASSET__Blih1V6T__"